export default __webpack_public_path__ + "static/intro-tile-4-photography-b9c19cf9717d1fe0eda36dfadec5f2af.jpg";